import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const showMarkSpreadsheetAtom = atomWithStorage<boolean>('show-mark-spreadsheet', false);

export const markFullscreenAtom = atom<boolean>(false);
